export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_LOCAL_DEVELOPMENT = process.env.NODE_ENV === 'local_development';
export const IS_DEVELOPMENT_ANY = IS_DEVELOPMENT || IS_LOCAL_DEVELOPMENT;
export const HAS_PRODUCTION_PLATFORM_LABEL =
	typeof process.env.PRODUCTION_PLATFORM_LABEL !== 'undefined' && process.env.PRODUCTION_PLATFORM_LABEL;
export const OLD_HOST_PATH = IS_LOCAL_DEVELOPMENT
	? `http://localhost:${process.env.DEVICE === 'desktop' ? '8787' : '8788'}`
	: '';
